import React from 'react'
import Helmet from 'react-helmet'

import QuizWrapper from './components/QuizWrapper'
import './App.css'

function AppFont() {
  if (process.env.NODE_ENV !== 'production') {
    return (
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css?family=Raleway:300,400,600,700"
          type="text/css"
          rel="stylesheet"
        />
        <meta name="quiz-version" content={process.env.REACT_APP_VERSION} />
      </Helmet>
    )
  }
  return null
}

function App() {
  return (
    <div className="App">
      <AppFont />
      <QuizWrapper />
    </div>
  )
}

export default App
